import { View } from 'react-native'

export default function Line() {
  return <View className="flex h-px w-full bg-black/10" />
}
